import { ValueObjectError } from '../shared/errors';

/**
 * コースIDの型
 * 基礎編('basic')またはアドバンスト編('advanced')
 */
export type CourseIdType = 'basic' | 'advanced';

/**
 * コースIDの値オブジェクト
 * 基礎編('basic')またはアドバンスト編('advanced')
 */
export class CourseId {
  private constructor(private readonly value: CourseIdType) {}

  /**
   * 基礎編のコースIDを生成
   */
  static basic(): CourseId {
    return new CourseId('basic');
  }

  /**
   * アドバンスト編のコースIDを生成
   */
  static advanced(): CourseId {
    return new CourseId('advanced');
  }

  /**
   * 文字列からコースIDを復元
   */
  static fromString(value: string): CourseId {
    if (value === 'basic') {
      return CourseId.basic();
    }
    if (value === 'advanced') {
      return CourseId.advanced();
    }
    throw new ValueObjectError(
      `Invalid CourseId: ${value}. Must be 'basic' or 'advanced'`
    );
  }

  /**
   * 文字列表現を取得
   */
  toString(): CourseIdType {
    return this.value;
  }

  /**
   * 他のCourseIdと等価か判定
   */
  equals(other: CourseId): boolean {
    if (!(other instanceof CourseId)) {
      return false;
    }
    return this.value === other.value;
  }

  /**
   * 基礎編かどうか判定
   */
  isBasic(): boolean {
    return this.value === 'basic';
  }

  /**
   * アドバンスト編かどうか判定
   */
  isAdvanced(): boolean {
    return this.value === 'advanced';
  }

  /**
   * 値を取得（内部使用のみ）
   */
  getValue(): CourseIdType {
    return this.value;
  }
}
